import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { node, func, bool, string } from 'prop-types';
import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';
import { EMPTY_FUNCTION } from '@airasia-common/libraries/constants';
import Wrapper from '../Wrapper';
import Row from '../Container/Row';
import { SubBodyText } from '../Text/Heading';

const ShowMoreLabel = styled(SubBodyText)`
  cursor: pointer;
`;

ShowMoreLabel.displayName = 'ShowMoreLabel';

const ShowMore = ({
  visibleContent,
  collapseContent,
  onToggle,
  clickShowMore,
  theme,
  move,
  ...restProps
}) => {
  const [isCollapsed, expand] = useState(true);
  useEffect(() => {
    if (clickShowMore) {
      expand(!clickShowMore);
    }
  }, [clickShowMore]);
  return (
    <Wrapper {...restProps}>
      <Row>{visibleContent}</Row>
      {!isCollapsed && <Wrapper>{collapseContent}</Wrapper>}
      {collapseContent && (
        <Row>
          <ShowMoreLabel
            className="toogle-button"
            marginTop="4px"
            fontWeight="500"
            color={move ? 'tertiaryRed' : 'secondary'}
            onClick={() => {
              expand(!isCollapsed);
              onToggle(!isCollapsed);
            }}
          >
            {isCollapsed
              ? translate('common.showMore')
              : translate('common.showLess')}
          </ShowMoreLabel>
        </Row>
      )}
    </Wrapper>
  );
};

ShowMore.propTypes = {
  visibleContent: node,
  collapseContent: node,
  onToggle: func,
  clickShowMore: bool,
  theme: string,
  move: bool,
};

ShowMore.defaultProps = {
  onToggle: EMPTY_FUNCTION,
  clickShowMore: false,
};

export default ShowMore;
